<template>
	<!-- Vue Material Chip (stand alone chip) -->
	<!-- https://vuematerial.io/components/chips -->
	<md-chip
		:class="{
			'md-accent': secondary,
			'md-primary': primary,
		}"
		:md-clickable="clickable"
		:md-disabled="disabled"
		class="ui-chip"
		v-on="$listeners"
	>
		<slot/>
		<md-tooltip v-if="tooltip">{{ tooltip }}</md-tooltip>
	</md-chip>
</template>

<script>
export default {
	name: "Chip",
	props: {
		clickable: {
			type: Boolean,
			default: false,
			required: false
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false
		},
		primary: {
			type: Boolean,
			default: false,
			required: false
		},
		secondary: {
			type: Boolean,
			default: false,
			required: false
		},
		tooltip: {
			type: String,
			default: "",
			required: false
		}
	}
};
</script>
